export default __webpack_public_path__ + "f7fe0b1bf166020e4d5b53d69e4eb44f.svg";